class ComponentError {
  name: string
  component: string
  classes: string
  props: string
  stack: string

  constructor(error?: Partial<ComponentError>) {
    this.name = error?.name || ''
    this.component = error?.component || ''
    this.classes = error?.classes || ''
    this.props = error?.props || ''
    this.stack = error?.stack || ''
  }
}

export default ComponentError
